import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BRAND } from "@/data/siteData";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem("tmp_admin_token", res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      if (err?.response?.status === 401) {
        toast.error("Invalid admin credentials.");
      } else if (err?.code === "ERR_NETWORK" || !err?.response) {
        toast.error("Cannot reach the server. Check that the backend API is deployed and REACT_APP_BACKEND_URL is correct.");
      } else {
        toast.error("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#F9FAFB] to-white px-6">
      <form onSubmit={handleSubmit} className="w-full max-w-sm rounded-3xl border border-gray-200 p-8 bg-white shadow-sm">
        <img src={BRAND.logo} alt="The Market Place logo" className="h-14 mx-auto mb-6" />
        <h1 className="font-extrabold text-2xl text-center mb-6">Admin Login</h1>
        <div className="space-y-4">
          <div>
            <Label>Username</Label>
            <Input data-testid="admin-username-input" value={username} onChange={(e) => setUsername(e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 focus-visible:ring-[#D81B60]" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="w-full rounded-full bg-[#D81B60] text-white py-3 text-sm hover:bg-[#AD144B] transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
